export const absContrastColor = (c) => {
    const brightness = Math.max(c.r, c.g, c.b);
    const b2 = brightness > 120 ? 0 : 255;
    return ({
        r: b2,
        g: b2,
        b: b2,
    });
};
